module.exports = __webpack_public_path__ + "img/left_arrow.4a7901cc.svg";